import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getDealerVehicleSummaryFn = (dealers) => restHelpers.withBearer.get(restHelpers.dealersQueryString(`${K.API_URL}/dealers-summary?_=${new Date().getTime()}`,dealers), {});
const getAllFn = () => restHelpers.withBearer.get(`${K.API_URL}/dealers`, {});
const getFn = () => restHelpers.withBearer.get(`${K.API_URL}/dealers/find-one?_=${new Date().getTime()}`, {});

export default {
  getDealerVehicleSummary: getDealerVehicleSummaryFn,
  getAll: getAllFn,
  get: getFn
};
